// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-search {
  min-height: 0;
}
.filter-search__input {
  flex-shrink: 0;
  width: unset;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/search/ui/FilterSearch.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,cAAA;EACA,YAAA;AACJ","sourcesContent":[".filter-search {\n  min-height: 0;\n\n  &__input {\n    flex-shrink: 0;\n    width: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
